module.exports = __webpack_public_path__ + "5467419a75d93192fdcf4d461b15b8e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/paris.jpg
// module id = 646
// module chunks = 47